import TopHeader from "components/common/header";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import Tab from "components/common/Tab/tab";
import Tabs from "components/common/Tab/tabs";
import { useHighTotalScoreStockList } from "utils/clientAPIs/detailDiagnosis";
import Text from "components/common/List/Text";
import { KOREA } from "utils/constant/ITME_INFO";
import InterestStar from "components/templates/common/components/InterestStar";
import Img from "components/common/List/img";
import { HighScoreStockDetailSkeleton } from "components/skeleton/main";
import StockDetailLink from "components/common/StockDetailLink";
import { useMarketTabTracking } from "lib/analytics/react/hooks";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";
import AdSenseResponsive, {
  AD_SLOTS,
} from "components/ads/AdSenseResponsive";
import { ERROR_LOGO_URL, getPublicAssetUrl } from "utils/objectStorage";

function ScoreRanking({
  isMobile,
  initialList,
  initialLoc,
}: {
  isMobile: boolean;
  initialList?: any[] | null;
  initialLoc?: string;
}) {
  const router = useRouter();
  const { t } = useTranslation("main");
  const { loc } = router.query;
  const currentLoc = typeof loc === "string" ? loc : "";
  const clickHandler = () => {
    router.push("/");
  };
  const { trackClick } = useMarketTabTracking(
    currentLoc === "korea" ? "kr" : "us"
  );
  const [data, loading] = useHighTotalScoreStockList({
    limit: 100,
    loc: currentLoc,
    isDetail: true,
    fallbackData:
      currentLoc === (initialLoc || "") ? initialList ?? undefined : undefined,
  });

  const onTabClick = (loc: string) => {
    trackClick(loc === "korea" ? "kr" : "us");
    router.push(`/scoreranking?loc=${loc}`, undefined, { shallow: true });
  };

  const ListTemp = ({ asset, index }: { asset: any; index: number }) => {
    return (
      <TrackedListItem
        itemData={{
          kind: "stock",
          ticker: asset.ITEM_CD_DL,
          market: asset?.LOC === KOREA ? "kr" : "us",
        }}
        href={`/detail/${asset.ITEM_CD_DL}`}
        data-gtm-id={`score-ranking-list`}
        className={` w-full flex items-center  px-6 py-2  gap-3 bg-white cursor-pointer `}
      >
        <div className="flex gap-3 grow">
          <div className="justify-center items-center inline-flex">
            <span
              className={` text-center text-blue40  text-[15px] font-semibold leading-none whitespace-nowrap`}
            >
              {`${index + 1}`}
            </span>
          </div>
          <Img
            src={
              getPublicAssetUrl(`logos/${asset.ITEM_CD_DL}.png`) ||
              ERROR_LOGO_URL
            }
            HR_ITEM_NM={""}
          />

          <div
            className={`justify-start grow  overflow-hidden whitespace-pre-wrap flex-col  items-start inline-flex `}
          >
            <Text
              item={
                router.locale === "ko"
                  ? asset.ITEM_KR_NM && asset.ITEM_KR_NM
                  : asset.ITEM_ENG_NM && asset.ITEM_ENG_NM
              }
              price={
                router.locale === "ko"
                  ? asset.ADJ_CLOSE_KRW &&
                    asset.ADJ_CLOSE_KRW.toLocaleString("en-us", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }) + (asset.CAT !== "Index" ? "원" : "")
                  : asset.ADJ_CLOSE &&
                    asset.ADJ_CLOSE.toLocaleString("en-us", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }) +
                      (asset.CAT !== "Index"
                        ? asset?.LOC === KOREA
                          ? "₩"
                          : "$"
                        : "")
              }
              percent={asset.ADJ_CLOSE_CHG.toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              })}
            />
          </div>
        </div>

        <div className="flex items-center shrink-0 justify-end">
          <div>
            {
              <InterestStar
                asset={asset}
                size={30}
                triggerSectionId="ranking_attractive_stocks"
              />
            }
          </div>
        </div>
      </TrackedListItem>
    );
  };

  if (loading) {
    return (
      <main className="min-w-[360px] max-w-[800px] w-screen bg-white pb-4">
        <TopHeader clickHandler={clickHandler} />
        <HighScoreStockDetailSkeleton />
      </main>
    );
  }

  return (
    <main className="min-w-[360px] max-w-[800px] w-screen bg-white">
      <TopHeader clickHandler={clickHandler} />
      <div className="px-6 pt-[30px]">
        <span className={`${TYPO.TYPO4_SB} text-gray80`}>
          {t("highAttractivenessTop100")}
        </span>
      </div>
      <div className="pt-2">
        <Tabs type={"line"} isFull={true}>
          <Tab
            title={t("domestic")}
            onClick={() => onTabClick("korea")}
            isActive={currentLoc === "korea"}
            type={"line"}
          />
          <Tab
            title={t("overseas")}
            onClick={() => onTabClick("us")}
            isActive={currentLoc === "us"}
            type={"line"}
          />
        </Tabs>
      </div>
      <TrackedList listId="ranking_attractive_stocks" totalCount={data?.length}>
        <div className="py-2 flex flex-col gap-2">
          {data?.map((asset: any, index: number) => {
            return <ListTemp asset={asset} key={index} index={index} />;
          })}
        </div>
      </TrackedList>
      <AdSenseResponsive slot={AD_SLOTS.rankingBottom} className="mb-6" />
    </main>
  );
}

export default ScoreRanking;
